import { storage } from './storage';

export interface Settings {
  sound: boolean;
  voice: boolean;
  tutorialDone?: boolean;
}

const KEY = 'settings';
export const settings: Settings = { sound: true, voice: true, ...storage.getJSON<Partial<Settings>>(KEY) };

export function saveSettings(): void {
  storage.setJSON(KEY, settings);
}
